
import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {BaseComponent} from '../basecomponent.js';

/* global customElements */
class SectionTitle extends BaseComponent {

	static get properties() {
		return {
			// Not named "title": HTMLElement.title is the native browser tooltip attribute.
			headertext: {type: String, attribute: false},
			closable: {type: Boolean},
			collapsible: {type: Boolean}
		};
	}
	
	constructor() {
		super();
		
		var sectionTitle = this;
		
		sectionTitle.headertext = '';
		sectionTitle.closable = false;
		sectionTitle.collapsible = false;
		
		setTimeout(function(){
			sectionTitle.clearNativeTitleAttribute();
			sectionTitle.init();
		});
	}

	/**
	 * Keep ElementUtil.create({ title: '...' }) and element.title = '...' working
	 * without applying the native HTML title tooltip to the whole header.
	 */
	get title() {
		return this.headertext;
	}

	set title(value) {
		this.headertext = value == null ? '' : String(value);
		this.clearNativeTitleAttribute();
	}

	setAttribute(name, value) {
		if (name === 'title') {
			this.headertext = value == null ? '' : String(value);
			return;
		}
		super.setAttribute(name, value);
	}

	clearNativeTitleAttribute() {
		if (this.hasAttribute('title')) {
			HTMLElement.prototype.removeAttribute.call(this, 'title');
		}
	}

	connectedCallback() {
		super.connectedCallback();
		if (this.hasAttribute('title')) {
			this.headertext = this.getAttribute('title') || '';
			this.clearNativeTitleAttribute();
		}
	}
	
	render() {	
		return html`
			<style>
				.header {
					background-color: #383636;
					border-bottom: 3px solid ${this.getAccentColor()};
					color: white;
					padding-top: 10px;
					padding-bottom: 10px;
				}
		
				.right-side {
					float: right;
				}
		
				.title-text {
					padding-left: 10px;
					font-size: 16px;
				}
		
			</style>
			<div class="header">
				<span class="title-text">
					${this.headertext}
				</span>
				<slot name="content"></slot>
				<span class="right-side">
					<slot name="right"></slot>
				</span>
			</div>
		`;
	}
	
	init() {
		var sectionTitle = this;
				
		if (sectionTitle.closable) {
			var closeBtn = ElementUtil.create({ 				
				tag: 'div',
				'class': 'panel-closebutton',
				slot: 'right',
				innerHTML: 'X',
				listeners: {
					click: function(event) {
						var cancelEvent = new CustomEvent('close', { detail: '' });
						sectionTitle.dispatchEvent(cancelEvent);					
					}
				}			
			});
			sectionTitle.append(closeBtn);
		}
		
		sectionTitle.open = true;
		if (sectionTitle.collapsible) {
			var collapseBtn = ElementUtil.create({ 				
				tag: 'div',				
				'class': 'panel-collapsebutton',
				slot: 'right',
				children:[
						sectionTitle.makeCollapseIcon('vaadin:angle-down')						
				],
				listeners: {
					click: function(event) {
						if (sectionTitle.open) {
							sectionTitle.collapse();				
						} else {
							sectionTitle.expand();
						}
						event.stopPropagation();
					}
				}			
			});
			sectionTitle.append(collapseBtn);
			sectionTitle.collapseBtn = collapseBtn;
			
			sectionTitle.addEventListener('click', function(){
				if (sectionTitle.open) {
					sectionTitle.collapse();				
				} else {
					sectionTitle.expand();
				}	
			});			
		}
	}

	makeCollapseIcon(iconName) {
		var iconWrapper = ElementUtil.makeIcon(iconName, '');
		var icon = iconWrapper.querySelector('vaadin-icon');
		if (icon) {
			icon.style.marginRight = '';
			icon.style.marginLeft = '5px';
		}
		return iconWrapper;
	}
	
	collapse() {
		var sectionTitle = this;
		sectionTitle.open = false;
		
		ElementUtil.removeAllChildren(sectionTitle.collapseBtn);
		sectionTitle.collapseBtn.append(sectionTitle.makeCollapseIcon('vaadin:angle-up'));

		var event = new CustomEvent('collapse', { detail: '' });
		sectionTitle.dispatchEvent(event);
	}
	
	expand() {
		var sectionTitle = this;
		sectionTitle.open = true;
		
		ElementUtil.removeAllChildren(sectionTitle.collapseBtn);
		sectionTitle.collapseBtn.append(sectionTitle.makeCollapseIcon('vaadin:angle-down'));
		
		var event = new CustomEvent('expand', { detail: '' });
		sectionTitle.dispatchEvent(event);
	}
	
	getAccentColor() {
		return window.DL.Branding.navBackgroundColor;	
	}	
	
};
customElements.define('dl-section-title', SectionTitle);

